export const POS_FAV_TAP_ACTIONS = Object.freeze({
  INCREMENT_ONE: 'increment-one',
  DECREMENT_ONE: 'decrement-one',
  CONFIRM_SCALE_READING: 'confirm-scale-reading',
  REMOVE_SCALE_READING: 'remove-scale-reading',
  WAIT_FOR_SCALE_READING: 'wait-for-scale-reading',
});

export const isPosFavScaleConnected = (scaleState) => Boolean(
  scaleState?.hasLiveScaleStream && scaleState?.connectionStatus === 'connected'
);

export const usesLiveScaleForPosFav = ({ usesScale, scaleConnected }) => (
  Boolean(usesScale && scaleConnected)
);

export const resolvePosFavTapAction = ({
  direction,
  usesScale = false,
  scaleConnected = false,
  scaleWeightKg = null,
}) => {
  if (direction !== 'increment' && direction !== 'decrement') {
    throw new TypeError('direction must be increment or decrement');
  }

  const usesLiveScale = usesLiveScaleForPosFav({ usesScale, scaleConnected });
  if (!usesLiveScale) {
    return direction === 'increment'
      ? POS_FAV_TAP_ACTIONS.INCREMENT_ONE
      : POS_FAV_TAP_ACTIONS.DECREMENT_ONE;
  }

  if (direction === 'decrement') {
    return POS_FAV_TAP_ACTIONS.REMOVE_SCALE_READING;
  }

  const normalizedWeightKg = Number(scaleWeightKg);
  return scaleWeightKg != null
    && Number.isFinite(normalizedWeightKg)
    && normalizedWeightKg > 0
    ? POS_FAV_TAP_ACTIONS.CONFIRM_SCALE_READING
    : POS_FAV_TAP_ACTIONS.WAIT_FOR_SCALE_READING;
};
